module.exports = __webpack_public_path__ + "public-roadmap-hero-e481dab0c25228435b2d185522cd9e7b.webp";